<template>
    <BasePanel headline="lang_CONTRACTS_CAPTION_CONDITIONS" :alvqa="alvqa">
      <template v-slot:panelContent>
        <v-container fluid class="pl-0">
          <v-row>
            <v-col>
              <v-data-table
                :headers="sheetsHeaders"
                :items="item"
                :expanded.sync="expandedItems"
                show-expand
                @click:row="expandItemByClick($event)"
                :header-props="{ sortIcon: '' }"
                :items-per-page="itemsPerPage"
                hide-default-footer
                sort-by="sheetNumber"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
              >
                <template
                  v-for="(header, i) in sheetsHeaders"
                  v-slot:[`header.${header.value}`]
                >
                  <span :alvqa="header.alvqa" :key="i + '_header'">{{
                    header.text
                  }}</span>
                </template>
  
                <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                  <v-icon
                    v-if="isExpanded"
                    small
                    class="ma-0 pa-0"
                    color="buttonStandard"
                    >fa-arrow-alt-circle-down</v-icon
                  >
                  <v-icon v-else small class="ma-0 pa-0" color="buttonStandard"
                    >fa-arrow-alt-circle-right</v-icon
                  >
                </template>
                <template v-slot:[`item.sourceId`]="{ item }">
                  <BaseTooltip>
                    <template v-slot:content>
                      <div
                        :alvqa="alvqa + '-sheets-' + item.id + '-text-sourceId'"
                        class="ellipsis"
                      >
                        {{ getSourceName(item.sourceId) }}
                      </div>
                    </template>
                    <template v-slot:text>
                      {{ getSourceName(item.sourceId, true) }}
                    </template>
                  </BaseTooltip>
                </template>
                <template v-slot:[`item.recipientId`]="{ item }">
                  <BaseTooltip>
                    <template v-slot:content>
                      <div
                        class="ellipsis"
                        :alvqa="
                          alvqa + '-sheets-' + item.id + '-text-recipientId'
                        "
                      >
                        {{ item.recipientId ? $alvPlugin.showNameOfAzEntry(item.recipientId) : $t('lang_GENERIC_CAPTION_ANY') }}
                        <BaseIcon
                          :alvqa="alvqa + '-icon-recipient-id-copy-to-clipboard'"
                          :small="true"
                          icon="content_copy"
                          color="buttonStandard"
                          v-if="item.recipientId"
                          @click.stop="copyToClipboard(item.recipientId.alvId)"
                        />
                      </div>
                    </template>
                    <template v-slot:text>
                      {{ item.recipientId ? `${item.recipientId.gemaName} (${item.recipientId.alvId})` : $t('lang_GENERIC_CAPTION_ANY') }}
                    </template>
                  </BaseTooltip>
                </template>
                <!-- SVAV columns - only rendered when headers include them (AUV contracts) -->
                <template v-slot:[`item.svavPublisherQuota`]="{ item }">
                  <div
                    :alvqa="alvqa + '-sheets-' + item.id + '-text-svav-publisher-quota'"
                    class="ellipsis"
                  >
                    {{ item.svavPublisherQuota ? $alvPlugin.getNumberLocalization(item.svavPublisherQuota, 'number') + '%' : '' }}
                  </div>
                </template>
                <template v-slot:[`item.svavShareType`]="{ item }">
                  <div
                    :alvqa="alvqa + '-sheets-' + item.id + '-text-svav-share-type'"
                    class="ellipsis"
                  >
                    {{ getSvavShareTypeName(item) }}
                  </div>
                </template>
  
                <template v-slot:expanded-item="{ item }">
                  <td
                    colspan="1"
                    style="background-color: var(--v-expandPanelBackground-base)"
                  ></td>
                  <td
                    class="pl-0"
                    :colspan="sheetsHeaders.length - 1"
                    style="background-color: var(--v-expandPanelBackground-base)"
                  >
                    <v-container fluid class="pl-0 pr-0">
                      <v-row>
                        <v-col class="pr-0">
                          <v-data-table
                            :headers="splitsHeaders"
                            hide-default-footer
                            :items="item.splits"
                            item-key="index"
                            :header-props="{ sortIcon: '' }"
                            :no-data-text="
                              $t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
                            "
                            :items-per-page="itemsPerPage"
                            class="noMinWidth"
                          >
                            <template
                              v-for="(header, i) in splitsHeaders"
                              v-slot:[`header.${header.value}`]
                            >
                              <span
                                :alvqa="header.alvqa + '-' + item.sheetNumber"
                                :key="i"
                                >{{ header.text }}</span
                              >
                            </template>
  
                            <template v-slot:[`item.rightsType`]="{ item }">
                              <BaseTooltip>
                                <template v-slot:content>
                                  <div
                                    class="ellipsis"
                                    :alvqa="
                                      alvqa +
                                      '-conditions-list-row-' +
                                      item.id +
                                      '-text-rights-type'
                                    "
                                  >
                                    {{ getRightTypeName(item.rightsType) }}
                                  </div></template
                                >
                                <template v-slot:text>{{
                                  getRightTypeName(item.rightsType)
                                }}</template>
                              </BaseTooltip>
                            </template>
                            <template v-slot:[`item.category`]="{ item }">
                              <BaseTooltip>
                                <template v-slot:content>
                                  <div
                                    class="ellipsis"
                                    :alvqa="
                                      alvqa +
                                      '-conditions-list-row-' +
                                      item.id +
                                      '-text-category'
                                    "
                                  >
                                    {{ getCategoryName(item.category) }}
                                  </div>
                                </template>
                                <template v-slot:text>{{ getCategoryName(item.category) }}</template>
                              </BaseTooltip>
                            </template>
                            <template v-slot:[`item.subCategory`]="{ item }">
                              <BaseTooltip>
                                <template v-slot:content>
                                  <div
                                    class="ellipsis"
                                    :alvqa="
                                      alvqa +
                                      '-conditions-list-row-' +
                                      item.id +
                                      '-text-sub-category'
                                    "
                                  >
                                    {{ item.subCategory }}
                                  </div>
                                </template>
                                <template v-slot:text>{{ item.subCategory }}</template>
                              </BaseTooltip>
                            </template>
                            <template v-slot:[`item.base`]="{ item }">
                              <div
                                :alvqa="
                                  alvqa +
                                  '-conditions-list-row-' +
                                  item.id +
                                  '-text-abase'
                                "
                              >
                                {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                              </div>
                            </template>
                            <template v-slot:[`item.split`]="{ item }">
                              <div
                                :alvqa="
                                  alvqa +
                                  '-conditions-list-row-' +
                                  item.id +
                                  '-text-split'
                                "
                              >
                                {{ $alvPlugin.getNumberLocalization(item.split, 'number') }}
                              </div>
                            </template>
                            <template v-slot:[`item.weighting`]="{ item }">
                              <div
                                :alvqa="
                                  alvqa +
                                  '-conditions-list-row-' +
                                  item.id +
                                  '-text-weighting'
                                "
                              >
                                {{ geWeightingName(item.weighting) }}
                              </div>
                            </template>
                            <template v-slot:[`item.applyTo`]="{ item }">
                              <BaseTooltip>
                                <template v-slot:content>
                                    <div
                                        :alvqa="
                                        alvqa +
                                        '-conditions-list-row-' +
                                        item.id +
                                        '-text-apply-to'
                                        "
                                    >
                                        {{ getApplyToName(item.applyTo) }}
                                    </div>
                                </template>
                                <!-- this is the mouseover text -->
                                <template v-slot:text v-if="item.applyTo !='incomingMoney'">
                                    {{ item.recipientId ? `${item.recipientId.gemaName} (${item.recipientId.alvId})` : '' }}
                                </template>
                                <template v-slot:text v-else>
                                    {{ getApplyToName(item.applyTo) }}
                                </template>
                            </BaseTooltip>
                            </template>
                            <template v-slot:[`item.region`]="{ item }">
                              <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                                {{ $alvPlugin.createRegionsToString(item.region) }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-container>
                  </td>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </BasePanel>
  </template>
  
  <script>
  import BasePanel from "@/components/_base/BasePanel";
  import BaseTooltip from "@/components/_base/BaseTooltip";
  import BaseIcon from "@/components/_buttons/BaseIcon";
  import {
    DropdownRightsType,
    DropdownCategory,
    DropdownWeighting,
    DropdownContractsPublishingSplitsApplyTo,
    DropdownWeightingSource,
  } from "@/assets/dropdowns/alvDropdowns.js";
  
  export default {
    name: "PublishingContractsConditionsReadOnlyPanel",
    components: {
      BasePanel,
      BaseTooltip,
      BaseIcon,
    },
    props: {
      itemId: {
        type: Number,
      },
    },
    data() {
      return {
        expandedItems: [],
        alvqa:
          "publishing-contracts-conditions-list-row-" +
          this.itemId +
          "-read-only",
        context: "PublishingContract",
      };
    },
    computed: {
      item() {
        this.$store.commit("setIsLoading", true);
        this.$store.dispatch("fetchPublishingContractConditions");
        return this.$store.getters.getPublishingContractConditions;
      },
      sheetsHeaders() {
        let headers = [
          {
            text: "",
            value: "data-table-expand",
            align: "center",
            width: "48px",
          },
          {
            text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SOURCE"),
            value: "sourceId",
            align: "left",
            sortable: false,
            class: "text-no-wrap",
            width: "20%",
            alvqa: this.alvqa + "-sheets-header-source-id",
          },
          {
            text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_RECIPIENT"),
            value: "recipientId",
            align: "left",
            sortable: false,
            width: this.isAuvContract ? "40%" : "70%",
            alvqa: this.alvqa + "-sheets-header-recipient-id",
          }
        ];
        
        // SVAV columns - only for AUV contract type
        if (this.isAuvContract) {
          headers.push({
            text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_SVAV_PUBLISHER_QUOTA"),
            value: "svavPublisherQuota",
            align: "left",
            sortable: false,
            width: "15%",
            class: "text-no-wrap",
            alvqa: this.alvqa + "-sheets-header-svav-publisher-quota",
          });
          headers.push({
            text: this.$t("lang_PUBLISHING_CAPTION_SHARE_TYPE"),
            value: "svavShareType",
            align: "left",
            sortable: false,
            width: "15%",
            class: "text-no-wrap",
            alvqa: this.alvqa + "-sheets-header-svav-share-type",
          });
        }
        
        return headers;
      },
      isAuvContract() {
        return this.$store.getters.getPublishingContractsDetailsContractType === 'AUV';
      },
      splitsHeaders() {
        return [
          {
            text: this.$t("lang_GENERIC_CAPTION_RIGHTS_TYPE"),
            value: "rightsType",
            align: "left",
            sortable: false,
            class: "text-no-wrap",
            alvqa: this.alvqa + "-conditions-splits-header-rights-type",
          },
          {
            text: this.$t("lang_GENERIC_CAPTION_CATEGORY"),
            value: "category",
            align: "left",
            sortable: false,
            alvqa: this.alvqa + "-conditions-splits-header-category",
          },
          {
            text: this.$t("lang_PUBLISHING_INCOME_CAPTION_SUB_CATEGORY"),
            value: "subCategory",
            align: "left",
            sortable: false,
            alvqa: this.alvqa + "-conditions-splits-header-sub-category",
          },
          {
            text: this.$t("lang_GENERIC_CAPTION_REGION"),
            value: "region",
            align: "left",
            sortable: false,
            alvqa: this.alvqa + "-conditions-splits-header-region",
          },
          {
            text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_BASE"),
            value: "base",
            sortable: false,
            width: "70px",
            align: "left",
            class: "text-no-wrap",
            alvqa: this.alvqa + "-conditions-splits-header-base",
          },
          {
            text: `${this.$t("lang_GENERIC_CAPTION_SPLIT")}%`,
            value: "split",
            align: "left",
            width: "70px",
            sortable: false,
            class: "text-no-wrap",
            alvqa: this.alvqa + "-conditions-splits-header-split",
          },
          {
            text: this.$t("lang_PUBLISHING_CAPTION_WEIGHTING"),
            value: "weighting",
            align: "left",
            sortable: false,
            class: "text-no-wrap",
            alvqa: this.alvqa + "-conditions-splits-header-weighting",
          },
          {
            text: this.$t("lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_APPLY_TO"),
            value: "applyTo",
            sortable: false,
            align: "left",
            class: "text-no-wrap",
            alvqa: this.alvqa + "-conditions-splits-header-apply-to",
          }
        ];
      },
      itemsPerPage() {
        return this.$store.getters.getItemsPerPage;
      },
      applyToDropdownItems() {
        let alvqa = this.alvqa + "-dropdown-apply-to";
        let applyToArr;
        let applyTo = DropdownContractsPublishingSplitsApplyTo;
  
        if (applyTo !== undefined) {
          applyToArr = JSON.parse(JSON.stringify(applyTo));
          applyToArr.forEach((element) => {
            element["alvqa"] = alvqa + element.value;
          });
        }
        return applyToArr;
      },
    },
    methods: {
      copyToClipboard(item) {
        navigator.clipboard.writeText(item);
      },
      getApplyToName(value) {
        var current = this.applyToDropdownItems.find((el) => el.value == value);
        return current ? this.$t(current.text) : "";
      },
      geWeightingName(value) {
        var current = DropdownWeighting.find((el) => el.value == value);
        return current ? this.$t(current.text) : "";
      },
      getCategoryName(value) {
        // var current = DropdownCategory.find((el) => el.value == value);
        return value;
      },
      getSourceName(value, detailed=false) {
        if (!value || (Array.isArray(value) && value.length === 0)) {
          return this.$t('lang_GENERIC_CAPTION_ANY')
        }
        if (!Array.isArray(value)) { return ; }

        // Filter out selected sources and map into array of source names
        let foundSourceNames = this.$store.getters.getAzForMappingsImport.filter(
          (el) => value.includes(el.value)
        ).map((el) => {
          if (this.$alvPlugin.isLangConst(el.text)) {
            return this.$t(el.text)
          }
          return el.text
        });

        if (detailed === true || foundSourceNames.length === 1) {
          return foundSourceNames.join(', ')
        }

        return this.$t('lang_GENERAL_CAPTION_MULTIPLE');
      },
      getRightTypeName(value) {
        var current = DropdownRightsType.find((el) => el.value == value);
        return current ? this.$t(current.text) : "";
      },
      getSvavShareTypeName(item) {
        // First check in standard share types (role, intl, own)
        let foundItem = DropdownWeightingSource.find((el) => el.value == item.svavShareType);
        if (foundItem) {
          return this.$t(foundItem.text);
        }
        // Otherwise it's a society code - get the society name
        if (item.svavShareType) {
          return this.$alvPlugin.getSocietyPanelHeadline(parseInt(item.svavShareType));
        }
        return "";
      },
      // Expand behaviour when clicking on a row.
      async expandItemByClick(item) {
        if (this.expandedItems.includes(item)) {
          // close item.
          let indexOfItem = this.expandedItems.indexOf(item);
          this.expandedItems.splice(indexOfItem, 1);
        } else {
          // open item
          this.expandedItems.push(item);
        }
      },
    },
    created() {
      this.$store.commit('setSocieties')
      this.$store.dispatch('fetchAzForMappings');
    }
  };
  </script>
  
  <style>
  .noMinWidth table {
    min-width: 0px !important;
    table-layout: fixed;
  }
  </style>